export default __webpack_public_path__ + "static/media/06_photo.4f14dec8.jpg";